var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"page-header"},[_c('span',[_vm._v(_vm._s(_vm.headerTitle))]),_vm._v(" "),_c('span',{staticClass:"sub_title"},[_vm._v(_vm._s(_vm.headerSubtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/components/HeaderTitle.vue?vue&type=template&id=b5486a22&scoped=true&
// module id = null
// module chunks = 